<template>
    <div v-if="checklist" ref="container" id="detail-content" class="content scrollbar right" :class="$mq">
        <div class="top-container" :class="{ infoOpened: infoIsOpen }">
            <AppccTopDetail @deleteButton="deleteIssue()" @infoOpened="infoOpened" @backButton="back()" :notAvailable="dependency_tpl" :checklist="checklist" :title="checklist.title" :createdAt="checklist.created_date" :completed="checklist.complete_date" @settingsButton="settingsRegister" :hasMoreOptions="hasMoreOptions" :taskType="true" :hasReopen="false" :hasDelete="false" />
        </div>

        <!-- SECTIONS NAV BAR  -->
        <div class="sections-navbar" v-if="hasSections" v-show="shouldShowSectionsNavbar">
            <TemplateSections :sections="sections" :doneSectionsIds="doneSectionsIds" :firstNotDoneSectionId="firstNotDoneSectionId" />
        </div>

        <!-- PROGRESS BAR -->
        <div class="progress-bar-section">
            <ProgressBar v-if="checklist" :itemsCompleted="checklist.completed" :itemsTotal="checklist.total" :needJustification="checklist.need_justification" />
        </div>

        <!-- SEARCH BAR -->
        <div class="search-bar-container" v-if="showSearchBar">
            <SearchBar :search="searchValue" :show-qr-icon="canSearchTasksByQrId" @on-search="handleSearch" @on-button-click="handleClearSearch" @on-qr-click="openQrScanner" :placeholder="$t('detail.sections_search.placeholder')" />
        </div>

        <!-- OVERLAY ESCÁNER QR -->
        <div v-if="showQrOverlay" class="qr-scanner-overlay" @click.self="closeQrOverlay">
            <div class="qr-scanner-mask">
                <StreamBarcodeReader v-if="qrScanActive" @decode="onQrDecode" class="qr-scanner-reader" />
            </div>
            <button type="button" class="qr-scanner-close" aria-label="Cerrar escáner" @click.stop="closeQrOverlay">
                <i class="i-andy-close i-andy-m"></i>
            </button>
        </div>

        <!-- DETAIL BOX (items) -->
        <div class="detail-box" :class="[{ 'with-sections': shouldShowSectionsNavbar }, { 'opened-info': infoIsOpen }, { 'with-search-bar': shouldShowSearchBar }]">
            <div class="exam" id="exam" :class="[editable ? 'performing' : '', { 'with-sections': shouldShowSectionsNavbar }, { 'hide-scrollbar': ['portrait'].includes($mq) }, { scrollbar: ['landscape', 'desktop'].includes($mq) }]">
                <div class="detail-exam-preamble">
                    <Banner v-if="dependency_tpl" type="error" :message="getStringVariable('answer.dependency_tpl', dependency_tpl.title)"></Banner>

                    <div v-if="checklist.need_justification && !checklist.justify_id && checklist.completed != checklist.total" class="justify-description">
                        <div class="alex"></div>
                        <div class="message keep-format" v-html="getString('answer.justify.pending_desc')"></div>
                        <div class="action" @click="justify">
                            {{ getString('answer.justify.justify_it') }}
                        </div>
                    </div>
                    <div v-if="checklist.need_justification && checklist.justify_id" class="justify-description">
                        <div class="alex"></div>
                        <div class="message keep-format" v-html="getStringVariables('answer.justify.justified_desc', reasonDesc)"></div>
                    </div>

                    <SimpleToast v-if="checklist.description" :key="checklist.id" :text="checklist.description" :includeToggleButton="true" type="checklist-description" :parse="true" />

                    <div class="note-detail">
                        <NoteDetail v-if="notes && notes.length > 0" :notes="notes" />
                    </div>

                    <div v-if="checklist.recover && editable && !checklist.complete_date && checklistAvailability()" class="get-last-values">
                        <span class="message" @click="recoverValues()">{{ $t('tasks.get_last_values') }}</span>
                    </div>

                    <div v-if="checklist.multiple && editable" class="question complete-all">
                        <div class="item">
                            <div class="answer">
                                <div class="line">
                                    <div class="statement">
                                        <div class="answer-title keep-format" v-html="$t('tasks.multiple_resolve')"></div>
                                    </div>
                                    <div class="response">
                                        <span class="value" :class="completeAllClasses" @click="resolveTasks()"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="checklist" class="detail-exam-checklist">
                    <template v-if="showNoResultsEmptyState">
                        <EmptyPage :description="searchNoResultsMessage" />
                    </template>
                    <template v-else>
                        <!-- ITEMS (if sections, sections and items) -->
                        <Answer v-for="answer in checklistItems" @section-toggled="(sectionId, isOpen) => handleShowOrHideSectionItems(sectionId, isOpen)" :class="{ hidden: closedSectionsIds.includes(answer.section_id) }" :doneSectionsIds="doneSectionsIds" @cleanDependency="cleanDependency" :hasDependency_tpl="dependency_tpl" :key="answer.item_id" :item="answer" :list="checklist" :cId="checklist.id" :aId="answer.item_id" :cType="type" :timeRefreshKey="timeRefreshKey" />
                    </template>
                    <div class="settings" v-if="[$mq].includes('portrait')">
                        <span @click="settingsRegister">{{ $t('menu_aux.action.settings') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else class="content hide-scrollbar right empty">
        <EmptyPage :buttonText="$t('empty_pages.return_tasks')" @buttonAction="back()" buttonClass="back" :type="'error'" :title="$t('assets.overlay.timeout.message')" :description="$t('empty_pages.error_checklists')"></EmptyPage>
    </div>
</template>

<script>
import EmptyPage from '../../layout/EmptyPage.vue'
import Answer from '@/components/domain/tasks/answer'
import SimpleToast from '@/components/layout/SimpleToast'
import TemplateSections from '@/components/layout/TemplateSections'
import AppccTopDetail from '@/components/layout/AppccTopDetail'
import Banner from '@/components/layout/Banner'
import NoteDetail from '../../layout/NoteDetail.vue'
import ProgressBar from '@/components/domain/ui/ProgressBar.vue'
import SearchBar from '@/components/domain/ui/SearchBar.vue'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import { FORMAT } from '@/constants'
import { getCustomApply, getFirstCustomRecord } from '@/utils/templateCustom'
import { getLocationMoment } from '@/utils/locationTime'
import nativeBarcodeScanner from '@/mixins/nativeBarcodeScanner'

export default {
    mixins: [nativeBarcodeScanner],
    components: {
        Answer,
        EmptyPage,
        TemplateSections,
        AppccTopDetail,
        Banner,
        NoteDetail,
        ProgressBar,
        SearchBar,
        StreamBarcodeReader,
        SimpleToast
    },
    props: {
        gId: { type: String },
        askTitle: { type: Boolean, default: false }
    },
    data() {
        return {
            collapsedInfo: false,
            type: 1,
            infoIsOpen: false,
            dependency_tpl: false,
            showNonApply: true,
            hasMoreOptions: false,
            closedSectionsIds: [],
            searchValue: '',
            searchResult: [],
            timerSearch: null,
            timeRefreshInterval: null,
            timeRefreshKey: Date.now(),
            FORMAT: FORMAT
        }
    },
    computed: {
        sectionsWithVisibleItemIds() {
            const ids = new Set()
            const titleTypes = this.checklist.def && this.checklist.def.item ? this.checklist.def.item.itemsTitle : [FORMAT.TITLE, FORMAT.SUBTITLE]
            Object.values(this.checklist.items).forEach((item) => {
                if (item.section_id && getCustomApply(item) !== 0 && !titleTypes.includes(Number(item.type))) {
                    ids.add(item.section_id)
                }
            })
            return ids
        },
        orderedAndVisibleChecklistItems() {
            if (!this.checklist || !this.checklist.items) {
                return []
            }

            const allItems = Object.values(this.checklist.items)
            const orderedItems = this.orderItemsByHierarchy(allItems)

            return orderedItems.filter((item) => item.is_visible)
        },
        checklistItems() {
            // Usar solo searchValue para decidir si hay búsqueda activa (no hasSections),
            // para que la búsqueda funcione también en tareas sin secciones (QR o equipment_id).
            const allItems = this.searchValue.length > 0 ? this.searchResult : this.orderedAndVisibleChecklistItems

            const titleTypes = this.checklist.def && this.checklist.def.item ? this.checklist.def.item.itemsTitle : [FORMAT.TITLE, FORMAT.SUBTITLE]

            return allItems.filter((item) => {
                if (getCustomApply(item) === 0) return false
                if (titleTypes.includes(Number(item.type))) {
                    // Sin secciones no filtramos por sectionsWithVisibleItemIds para no vaciar el resultado.
                    return !this.hasSections || this.sectionsWithVisibleItemIds.has(item.item_id)
                }
                return true
            })
        },
        hasSections() {
            return this.sections && this.sections.length > 1
        },
        shouldShowSectionsNavbar() {
            const isMobile = this.$mq === 'portrait'
            const isUserTyping = this.$store.getters['tasks/isUserTyping']

            // Ocultar solo si es móvil Y el usuario está escribiendo
            return this.hasSections && !(isMobile && isUserTyping)
        },
        showSearchBar() {
            if (this.canSearchTasksByQrId) return true
            if (this.hasSections && this.sections.length >= 5) return true
            if (!this.checklist || !this.checklist.items) return false
            return this.hasItemWithEquipmentId
        },
        shouldShowSearchBar() {
            const isMobile = this.$mq === 'portrait'
            const isUserTyping = this.$store.getters['tasks/isUserTyping']

            // No mostrar search bar mientras es móvil y el usuario escribe en un input de texto
            if (isMobile && isUserTyping) return false
            return this.showSearchBar
        },
        done() {
            return parseInt((this.checklist.completed / this.checklist.total) * 100)
        },
        employeeLogged() {
            var idEmployee = this.$store.getters['loginUser/getLocalEmployee']
            return this.$store.getters['employee/getEmployee'](idEmployee)
        },
        state() {
            var now = getLocationMoment(this.$store.getters, new Date(this.timeRefreshKey))
            var start = moment.utc(this.checklist.limit.start)
            var end = moment.utc(this.checklist.limit.end)

            var state = false

            if (start.isAfter(now)) state = 'future'
            else if (end.isSameOrBefore(now)) state = 'past'
            else if (start.isSameOrBefore(now) && end.isSameOrAfter(now)) {
                state = 'intime'
            }

            this.checklist.state = state

            return state
        },
        checklist() {
            const checklist = this.$store.getters['tasks/getById'](this.gId)

            if (checklist) {
                // SAVE TIMEFRAMEID AND DATE OF CHECKLIST
                log('setDateTimeframe', checklist.business_date, checklist.timeframe_id)
                this.$emit('setDateTimeframe', moment.utc(checklist.business_date), checklist.timeframe_id)
            } else {
                this.$bar.hide()
            }
            return checklist
        },
        sections() {
            const titleTypes = this.checklist.def && this.checklist.def.item ? this.checklist.def.item.itemsTitle : [FORMAT.TITLE, FORMAT.SUBTITLE]

            return Object.values(this.checklist.items).filter((item) => titleTypes.includes(Number(item.type)) && !item.section_id && getCustomApply(item) !== 0 && this.sectionsWithVisibleItemIds.has(item.item_id))
        },
        editable() {
            let now = getLocationMoment(this.$store.getters, new Date(this.timeRefreshKey))
            let limit = this.checklist.limit

            if (now.isBetween(limit.start, limit.end) || now.isBefore(limit.start)) {
                return true
            }
            return false
        },
        leftTime() {
            return this.$root.timeLeft(this.checklist.schedule.end)
        },
        stillAvailable() {
            let now = getLocationMoment(this.$store.getters, new Date(this.timeRefreshKey))
            let limit = this.checklist.limit
            let schedule = this.checklist.schedule

            if (now.isBetween(limit.start, limit.end) && !now.isBetween(schedule.start, schedule.end) && now.isAfter(schedule.end)) {
                return true
            }
            return false
        },

        // VIEW RESOURCES
        // stillAvailableFormatted() {
        //     return this.getStringVariable('answer.still_available', moment(this.checklist.schedule.end).format('HH'))
        // },
        completeAllClasses() {
            return this.$store.getters['tasks/getCheckTasksState'](this.gId)
        },
        reasonDesc() {
            let reasons = this.$store.getters['getReasonJustify']
            return {
                reason_name: reasons ? this.$t(reasons[this.checklist.justify_id].name) : i18n.$t('answer.justify.default_reason'),
                reason_msg: this.checklist.justify_msg ? this.checklist.justify_msg : '',
                reason_date: this.checklist.justify_date ? this.checklist.justify_date : '',
                reason_user: this.checklist.justify_user_id ? this.$store.getters['employee/getEmployee'](this.checklist.justify_user_id).name + ' ' + this.$store.getters['employee/getEmployee'](this.checklist.justify_user_id).surname : ''
            }
        },
        futureChecklist() {
            return moment.utc(this.checklist.business_date).startOf('day').isAfter(getLocationMoment(this.$store.getters).startOf('day'))
        },
        notes() {
            return this.$store.getters['tasks/getNotesById'](this.gId)
        },
        doneSectionsIds() {
            if (!this.checklist.sections) {
                return []
            }

            let doneSectionsIds = []

            const checklistSections = Object.values(this.checklist.sections)

            for (const section of checklistSections) {
                const sectionItemsAndSubitems = Object.values(this.checklist.items).filter((item) => item.section_id === section.section_id)

                const onlyItemsAndVisibleSubitems = sectionItemsAndSubitems.filter((item) => getCustomApply(item) !== 0 && (!item.parent_id || (item.parent_id && item.is_visible)))

                if (onlyItemsAndVisibleSubitems.every((item) => this.isItemCompleted(item))) {
                    doneSectionsIds.push(section.section_id)
                }
            }

            return doneSectionsIds
        },
        firstNotDoneSectionId() {
            if (!this.checklist.sections || !this.doneSectionsIds) {
                return null
            }

            const allSectionsIds = Object.keys(this.checklist.sections)

            return allSectionsIds.find((sectionId) => !this.doneSectionsIds.includes(sectionId))
        },
        hasItemWithEquipmentId() {
            if (!this.checklist || !this.checklist.items) return false
            return Object.values(this.checklist.items).some((item) => {
                const rec = getFirstCustomRecord(item.custom)
                const fromCustom = rec && rec.equipment_id != null && String(rec.equipment_id).trim() !== ''
                const fromItem = item.equipment_id != null && item.equipment_id !== ''
                return fromCustom || fromItem
            })
        },
        canSearchTasksByQrId() {
            const config = this.$store.getters['login/getConfig']
            if (!config || config.CAN_SEARCH_TASKS_BY_QR_ID !== true) return false
            return this.hasItemWithEquipmentId || (this.hasSections && this.sections.length >= 6)
        },
        showNoResultsEmptyState() {
            // Solo searchValue y searchResult (sin guard de hasSections) para mostrar vacío también en tareas sin secciones.
            return this.searchValue.length > 0 && this.searchResult.length === 0
        },
        searchNoResultsMessage() {
            return this.$t('empty_pages.sections_not_found', { searchInput: this.searchValue })
        }
    },
    methods: {
        refreshTimeKey() {
            this.timeRefreshKey = Date.now()
        },
        handleVisibilityRefresh() {
            if (!document.hidden) {
                this.refreshTimeKey()
            }
        },
        startTimeRefresh() {
            this.stopTimeRefresh()
            this.refreshTimeKey()
            this.timeRefreshInterval = setInterval(() => {
                this.refreshTimeKey()
            }, 30000)
            document.addEventListener('visibilitychange', this.handleVisibilityRefresh)
        },
        stopTimeRefresh() {
            if (this.timeRefreshInterval) {
                clearInterval(this.timeRefreshInterval)
                this.timeRefreshInterval = null
            }
            document.removeEventListener('visibilitychange', this.handleVisibilityRefresh)
        },
        /**
         * Determina si un item del checklist está completado.
         * Los items tipo LINK y RESOURCE se consideran siempre completados porque no guardan un valor.
         * @param {Object} item - El item del checklist a evaluar
         * @returns {boolean} - true si el item está completado, false en caso contrario
         */
        isItemCompleted(item) {
            return (item.value !== null && item.value !== '') || item.apply == 0 || getCustomApply(item) === 0 || item.type === FORMAT.LINK || item.type === FORMAT.RESOURCE
        },
        handleSearch(event) {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            const value = event && event.target && event.target.value != null ? event.target.value : ''
            if (value) {
                this.timerSearch = setTimeout(() => {
                    this.searchValue = value
                    this.timerSearch = null
                }, 300)
            } else {
                this.searchValue = ''
            }
        },
        handleClearSearch() {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            this.searchValue = ''
        },
        onQrDecode(decoded) {
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            if (decoded && String(decoded).trim() !== '') {
                this.searchValue = String(decoded).trim()
                if (this.showQrOverlay) {
                    this.closeQrOverlay()
                }
            }
        },
        handleShowOrHideSectionItems(sectionId, isOpen) {
            if (isOpen) {
                this.closedSectionsIds.push(sectionId)
            } else {
                this.closedSectionsIds = this.closedSectionsIds.filter((id) => id !== sectionId)
            }
        },
        orderItemsByHierarchy(items) {
            const roots = []
            const childrenByParent = {}
            const sortByOrder = (a, b) => {
                const orderA = parseFloat(a.order)
                const orderB = parseFloat(b.order)
                const hasOrderA = Number.isFinite(orderA)
                const hasOrderB = Number.isFinite(orderB)

                if (hasOrderA && hasOrderB && orderA !== orderB) {
                    return orderA - orderB
                }

                return 0
            }

            items.forEach((item) => {
                if (!item.parent_id) {
                    roots.push(item)
                    return
                }

                if (!childrenByParent[item.parent_id]) {
                    childrenByParent[item.parent_id] = []
                }

                childrenByParent[item.parent_id].push(item)
            })

            roots.sort(sortByOrder)
            Object.keys(childrenByParent).forEach((parentId) => {
                childrenByParent[parentId].sort(sortByOrder)
            })

            const orderedItems = []
            const visited = new Set()

            const appendWithChildren = (item) => {
                if (!item || visited.has(item.item_id)) {
                    return
                }

                visited.add(item.item_id)
                orderedItems.push(item)

                const children = childrenByParent[item.item_id] || []
                children.forEach((child) => appendWithChildren(child))
            }

            roots.forEach((rootItem) => appendWithChildren(rootItem))

            // Fallback for orphaned nodes (parent missing in payload)
            items.forEach((item) => {
                if (!visited.has(item.item_id)) {
                    appendWithChildren(item)
                }
            })

            return orderedItems
        },
        checklistAvailability() {
            const now = getLocationMoment(this.$store.getters, new Date(this.timeRefreshKey))
            if (fnCheckConnection()) {
                if (this.checklist.limit.start && this.checklist.limit.end) {
                    // NO disponible
                    if (this.dependency_tpl) {
                        return false
                    }

                    // disponible
                    if (now > moment.utc(this.checklist.limit.start) && now < moment.utc(this.checklist.limit.end)) {
                        return true
                    }
                    // no disponible, dias antiguos
                    if (now > moment.utc(this.checklist.limit.end)) {
                        return false
                    }
                    // no disponible, dias futuros
                    if (now < moment.utc(this.checklist.limit.start)) {
                        return false
                    }
                }
            } else return false
        },
        settingsRegister() {
            const self = this
            this.$popup.itemSettings({
                itemSettings: {
                    noApply: {
                        label: self.$t('popup.item_settings.no_apply'),
                        value: self.showNonApply
                    }
                },
                callSave: (settings) => {
                    const itemSettings = settings.itemSettings
                    self.showNonApply = itemSettings.noApply.value
                    self.$popup.close()
                }
            })
        },
        cleanDependency() {
            this.dependency_tpl = false
        },
        infoOpened() {
            this.infoIsOpen = !this.infoIsOpen
        },
        back() {
            this.$router.push({ name: 'Checklist' })
        },
        getString(str) {
            return this.$t(str)
        },
        getStringVariables(str, params) {
            return this.$t(str, params)
        },
        getStringPlural(str, pos) {
            return this.$tc(str, pos)
        },
        getStringVariable(str, pos) {
            return this.$t(str, { s: pos })
        },
        getStringPluralVariable(str, pos, text) {
            return this.$tc(str, pos, { s: text })
        },

        recoverValues() {
            const canWorkOffline = this.$store.getters['getOffline']
            if (fnCheckConnection() && this.$store.getters['getFastConnection']) {
                var self = this
                self.$overlay.loading()

                self.$store.dispatch('tasks/recoverValues', { check: self.gId }).then(function (response) {
                    self.$overlay.hide()
                    self.$snackbar.info({ message: self.$t('tooltip.done') })
                })
            } else {
                this.$snackbar.error({ duration: 10000, closeable: true, message: this.$t('empty_pages.connection_description') })
            }
        },
        resolveTasks() {
            let self = this
            let employee = this.$store.getters['loginUser/getLocalEmployee']

            if (this.completeAllClasses == 'checked') {
                this.$store.dispatch('tasks/resetAll', { check: this.gId }).then(function (response) {
                    self.$snackbar.success()
                })
            } else {
                this.$store.dispatch('tasks/completeAll', { check: this.gId, emp: employee, date: moment().unix() }).then(function (response) {
                    self.$snackbar.success()
                })
            }
        },

        justify() {
            let thisItem = this
            let data = {
                showErrorReason: false,
                errorReason: thisItem.$t('answer.justify.error')
            }
            let list = thisItem.$store.getters['getReasonJustify']

            thisItem.$popup.justify({
                title: thisItem.$t('answer.justify.justify_it'),
                textSave: this.$t('popup.default.text_save'),
                textCancel: this.$t('popup.default.text_cancel'),
                data: data,
                list: list,
                callSave: function (self, store) {
                    if (!self.selected || (self.selected == 0 && self.message.trim() == '')) {
                        self.data.showErrorReason = true
                    } else {
                        thisItem.$overlay.loading()

                        self.data.showErrorReason = false

                        store.dispatch('tasks/justify', { check: thisItem.gId, reason: self.selected, description: self.message }).then(function (response) {
                            thisItem.$popup.close()
                            thisItem.$overlay.hide()
                            thisItem.$snackbar.info({ message: thisItem.$t('tooltip.done') })
                        })
                    }
                }
            })
        },
        goToReference() {
            if (this.checklist && this.checklist.data && this.checklist.data.ref) {
                this.$router.push({
                    name: 'ChecklistDetail',
                    params: {
                        id: this.checklist.data.ref.checklist,
                        checkType: 1,
                        toTaskId: this.checklist.data.ref.item
                    }
                })
            }
        },
        redirectPath(firstResult) {
            return this.$root.redirectPath(firstResult)
        },
        getMinHour(hourA, hourB) {
            return moment(hourA).valueOf() < moment(hourB).valueOf() ? hourA : hourB
        },
        getMaxHour(hourA, hourB) {
            return moment(hourA).valueOf() > moment(hourB).valueOf() ? hourA : hourB
        },
        // messageFutureTasks() {
        //     var msg = this.$t('tasks.futureChecklist')
        //     var day = formatRelative(moment(this.checklist.schedule.start).format('YYYY-MM-DD HH:mm:ss', false))

        //     return msg.replace('[day]', day)
        // }
        load() {
            var self = this
            if (this.checklist && this.checklist.config && this.checklist.config.dependency_tpl) {
                self.$store.dispatch('tasks/checkDependencyTpl', { tpl: self.checklist.config.dependency_tpl }).then(function (response) {
                    self.dependency_tpl = response
                    //Si devuelve no devuelve false y el complete_date falla asegurar tambien que todos los items de la plantilla dependiente esten completados
                    if (self.dependency_tpl && self.dependency_tpl.total != self.dependency_tpl.completed) {
                        const isAllItemsAnswered = Object.values(self.dependency_tpl.items).every((item) => {
                            if (item.type !== 8 && item.apply && item.is_visible) {
                                const hasValue = item.value !== undefined && item.value !== null
                                return hasValue
                            }
                            return true
                        })

                        if (isAllItemsAnswered) {
                            self.dependency_tpl = false
                        }
                    } else if (self.dependency_tpl && self.dependency_tpl.total == self.dependency_tpl.completed) {
                        self.dependency_tpl = false
                    }
                })
            }
        },
        normalizeText(text) {
            if (!text) return ''

            return text
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remover diacríticos (tildes)
        }
    },
    filters: {
        moment: function (date, format) {
            return date ? moment(date).format(format) : ''
        }
    },
    created() {
        this.load()

        if (localStorage.getItem('showNonApply') != undefined) {
            this.showNonApply = localStorage.getItem('showNonApply') == 'true' ? true : false
        }

        if (['portrait'].includes(this.$mq)) {
            this.hasMoreOptions = false
        } else {
            this.hasMoreOptions = true
        }
    },
    mounted() {
        this.startTimeRefresh()
    },
    beforeRouteLeave() {
        this.$bar.hide()
        this.closeQrOverlay()
        this.destroyBarcode()
        this.stopTimeRefresh()
    },
    beforeDestroy() {
        this.stopTimeRefresh()
    },
    watch: {
        showNonApply(newValue, oldValue) {
            if (newValue !== oldValue) {
                localStorage.setItem('showNonApply', newValue)
                this.$store.commit('checklist/setShowNoApply', newValue)
            }
        },
        $mq(newValue, oldValue) {
            if (newValue === 'portrait') {
                this.hasMoreOptions = false
            } else {
                this.hasMoreOptions = true
            }
        },
        searchValue(newValue, oldValue) {
            if (!this.orderedAndVisibleChecklistItems) return

            if (newValue !== oldValue) {
                if (!newValue || newValue.length === 0) {
                    this.searchResult = []
                    return
                }
                const normalizedSearchValue = this.normalizeText(String(this.searchValue).trim())
                const allItems = Object.values(this.orderedAndVisibleChecklistItems)
                const idsOfSectionsToShow = []
                const resultIds = new Set()

                // 1) Secciones (type 8) cuyo título coincide
                for (const item of allItems) {
                    if (Number(item.type) === 8 && !item.section_id) {
                        const normalizedTitle = this.normalizeText(item.title || '')
                        if (normalizedTitle.includes(normalizedSearchValue)) {
                            idsOfSectionsToShow.push(item.item_id)
                            resultIds.add(item.item_id)
                        }
                    }
                }
                // 2) Items por equipment_id o título
                for (const item of allItems) {
                    const rec = getFirstCustomRecord(item.custom)
                    const equipmentIdFromCustom = rec && rec.equipment_id != null && String(rec.equipment_id).trim() !== '' ? String(rec.equipment_id).trim() : ''
                    const equipmentIdFromItem = item.equipment_id != null && item.equipment_id !== '' ? String(item.equipment_id).trim() : ''
                    const equipmentIdStr = equipmentIdFromCustom || equipmentIdFromItem
                    const normalizedEquipmentId = equipmentIdStr !== '' ? this.normalizeText(equipmentIdStr) : ''
                    const normalizedTitle = this.normalizeText(item.title || '')
                    const matchEquipment = normalizedEquipmentId !== '' && (normalizedEquipmentId === normalizedSearchValue || normalizedSearchValue.includes(normalizedEquipmentId) || normalizedEquipmentId.includes(normalizedSearchValue))
                    const matchTitle = normalizedTitle !== '' && normalizedTitle.includes(normalizedSearchValue)

                    let normalizedTitleCustom = ''
                    let matchTitleCustom = false
                    if (rec && rec.title) {
                        normalizedTitleCustom = this.normalizeText(rec.title || '')
                        matchTitleCustom = normalizedTitleCustom !== '' && normalizedTitleCustom.includes(normalizedSearchValue)
                    }

                    if (matchEquipment || matchTitle || matchTitleCustom) {
                        resultIds.add(item.item_id)
                        if (item.section_id && !idsOfSectionsToShow.includes(item.section_id)) {
                            idsOfSectionsToShow.push(item.section_id)
                        }
                    }
                }
                // 3) Construir lista: secciones incluidas + items de esas secciones + items por match directo
                const searchResult = allItems.filter((item) => {
                    if (Number(item.type) === 8 && !item.section_id) {
                        // Incluir si la sección entró por título (step 1) o por equipment_id/título (step 2)
                        return idsOfSectionsToShow.includes(item.item_id) || resultIds.has(item.item_id)
                    }
                    if (item.section_id && idsOfSectionsToShow.includes(item.section_id)) {
                        return true
                    }
                    return resultIds.has(item.item_id)
                })
                this.searchResult = searchResult
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#content.tasks.detail {
    $column-width: 20%;
    $column-max-width: rem(60px);
    $content-width: 80%;

    --progress-bar-height: 32px;

    @media (min-width: 768px) {
        --progress-bar-height: 52px;
    }

    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;

    > .content {
        $top-info: rem(90px);
        $resume-width: rem(150px);

        float: none !important;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden !important;
        padding-top: 0;
        padding-bottom: 0 !important;
        width: 100% !important;
        // width: calc(#{$content-width}) !important;
        // min-width: calc(100% - #{$column-max-width}) !important;

        .search-bar-container {
            flex-shrink: 0;
            width: 100%;
            padding-bottom: 16px;
            padding-right: 8px;
            padding-left: 8px;

            .search-container {
                .search {
                    font-size: 18px !important;
                    font-family: $text;
                    background-size: 18px !important;

                    @media (max-width: 767px) {
                        height: 40px !important;

                        .button {
                            width: 24px;
                            height: 24px;
                            background-size: 24px !important;
                        }
                    }
                }

                .search::placeholder {
                    font-size: 18px !important;
                    font-family: $text;
                }
            }
        }

        .detail-box {
            $sidebar-size: rem(40px);
            $collapse-button: rem(40px);
            $content-padding: rem(0px);
            $detail-bg: $default-bg-color;
            $detail-text-color: $main-dark;

            position: relative;
            padding: 0;
            padding-left: $content-padding;
            // padding-bottom: $menu-aux-height;
            width: 100%;
            background-color: $detail-bg;
            flex: 1 1 auto;
            min-height: 0;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .hidden {
                display: none;
            }

            .detail-exam-preamble {
                flex-shrink: 0;
                padding-right: 8px;
                padding-left: 8px;
                // para que alla un espacio entre el preamble y el checklist cuando se hace scroll
                padding-bottom: 8px;
            }

            // &.with-sections {
            //     // padding-top: $top-info + $sidebar-size;
            // }

            .detail-exam-checklist {
                flex: 1 1 auto;
                min-height: 0;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                gap: 8px;
                padding: 8px;
            }

            .note-detail {
                width: 100%;
                padding: 0 6px 0 12px;
                position: relative;
            }

            .exam {
                @include border-radius($default-border-radius);
                flex: 1 1 auto;
                min-height: 0;
                height: auto;
                overflow-x: hidden;
                overflow-y: auto;
                box-sizing: border-box;
                padding-bottom: env(safe-area-inset-bottom, 0px);

                // &:not(.performing) {
                //     // border: 2px solid #eee;
                //     // background-color: #eee;
                //     // filter: grayscale(70%);
                // }
                // &.performing {
                // }

                .settings {
                    @include display-flex();
                    @include justify-content(flex-end);
                    margin: 0 8px;

                    span {
                        @include font-size(sm);
                        font-family: $text-bold;
                        color: $main-dark;
                        text-decoration: underline;
                        cursor: pointer;
                    }
                }

                .futureTask {
                    width: 100%;
                    margin: 30px auto;
                    position: relative;

                    .item {
                        display: -webkit-inline-box;
                        display: -ms-inline-flexbox;
                        display: inline-flex;
                        -ms-flex-wrap: wrap;
                        flex-wrap: wrap;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        -webkit-box-pack: end;
                        -ms-flex-pack: end;
                        justify-content: flex-end;
                        background-clip: padding-box;
                        height: auto;
                        height: -moz-fit-content;
                        height: -webkit-fit-content;
                        height: fit-content;
                        width: 100%;
                        padding: 0;
                        overflow: hidden;
                        margin: 0;
                        -webkit-transition-duration: 0.2s;
                        transition-duration: 0.2s;
                        height: auto;
                        min-height: 3.125rem;

                        .answer {
                            @include background($image: img('alex_carita_07.svg'), $position: left 10px center, $size: 50px);
                            width: 100%;
                            background-color: $inactive;
                            display: -webkit-inline-box;
                            display: -ms-inline-flexbox;
                            display: inline-flex;
                            -webkit-box-align: center;
                            -ms-flex-align: center;
                            align-items: center;
                            -ms-flex-wrap: wrap;
                            flex-wrap: wrap;
                            width: 100%;
                            min-height: 4rem;
                            padding-right: 10px;
                            padding-left: 60px;

                            .line {
                                padding: 0 10px;

                                .statement {
                                    font-size: 1.125rem;
                                    width: 100%;
                                    // color: #222;
                                    font-family: 'Avenir-Regular';

                                    .answer-title {
                                        @include font-size(sm);
                                        color: #374673;
                                    }
                                }
                            }
                        }
                    }
                }

                .empty-page-content {
                    .content-message {
                        padding: 16px 24px !important;
                        width: fit-content !important;
                    }

                    .description {
                        padding-top: 0px !important;
                        font-size: 18px !important;
                    }
                }
            }
        }

        .top-container {
            flex-shrink: 0;
            position: sticky;
            top: 0;
            z-index: 20;
            background-color: $default-bg-color;
            width: 100%;
            padding: 8px;
            height: auto;
        }

        .sections-navbar {
            flex-shrink: 0;
            width: 100%;
            height: fit-content;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 8px;
            position: sticky;
            top: 0;
            z-index: 10;
        }

        .progress-bar-section {
            flex-shrink: 0;
            width: 100%;
            max-width: 100%;
            height: fit-content;
            position: sticky;
            top: 0;
            z-index: 10;
        }

        &.desktop {
            .top-container {
                background-color: $default-bg-color;
                width: 100%;
                max-height: 95px;
                padding: 8px;
            }
        }

        .justify-description {
            @include display-flex();
            @include align-items();
            @include background($color: shade($default-bg-color, 4%), $image: img('alexhead_03.svg'), $position: left 20px center, $size: 50px);
            width: 100%;
            padding: 16px 20px 16px 80px;
            margin: 0 auto 0 auto;
            $jd-button: rem(130px);

            .message {
                @include font-size(sm);
                font-family: $text;
                color: $main-dark;
                display: inline-block;
                overflow: visible;
                width: calc(100% - #{$jd-button});
                min-height: 20px;
                height: auto;
                padding-right: 12px;

                > span {
                    @include keepFormat();
                    font-family: $text;
                }
            }

            .action {
                @include interaction();
                @include border-radius(3px);
                @include background($warning);
                @include font-size(sm);
                color: #fff;
                font-family: $conden-bold;
                text-align: center;
                padding: 9px;
                width: $jd-button;
                min-height: 35px;
                display: inline-block;

                @include bgHover($warning);
            }
        }

        .get-last-values {
            text-align: center;

            .message {
                @include interaction();
                @include border-radius($default-border-radius);
                @include background($color: $main-t80, $image: img('download_primary.svg'), $position: right 12px center, $size: 22px);
                @include font-size(m);
                font-family: $text;
                color: $main-dark;
                padding: 12px 42px 12px 12px;
                display: inline-block;

                @include bgHover($main-t80);
            }
        }

        .check-available {
            @include background($color: shade($default-bg-color, 4%), $image: img('countdown_primary.svg'), $position: left 26px center, $size: 30px);
            width: 100%;
            padding: 16px 20px 16px 80px;
            margin: 0 auto 0 auto;

            .alex {
                @include background($image: img('alexhead_04.svg'), $size: contain, $position: left bottom);
                width: 40px;
                height: 40px;
                display: inline-block;
                margin-right: 6px;
            }

            .message {
                @include font-size(sm);
                font-family: $text;
                color: $main-dark;
                display: inline-block;
                overflow: visible;
                width: auto;
                max-width: calc(100% - 40px - 6px);
                min-height: 20px;
                height: auto;
            }
        }

        .question.complete {
            .check {
                @include border-radius(100%);
                @include background($size: 16px, $color: #fff);
                border: 2px solid #eee;
            }

            .check.checked {
                // @include background($size: cover, $image: img("checked_primary.svg") );
                @include background($size: cover, $image: img('checked_ok.svg'));
                border: none;
            }
        }
    }

    > .column.left {
        $content-space: 6px;

        width: $column-width !important;
        max-width: $column-max-width !important;
        // height: calc( 100% - ( #{$alex-app-padding} * 3) ) !important;

        .timeframes {
            .tframe {
                padding: 6px 0px 6px 6px;

                .graph.chart {
                    width: 30px;
                    height: 30px;
                }

                .title.condensed {
                    @include font-size(s, $important: true);
                    @include text-ellipsis();
                }

                &.alert {
                    position: relative;

                    &:before {
                        background-image: none !important;
                        min-width: 8px;
                        height: 8px;
                    }
                }
            }
        }
    }
}
</style>

<!--  PORTRAIT STYLES -->
<style lang="scss" scoped>
#detail-content.content.right.portrait {
    --progress-bar-height: 32px;

    @media (min-width: 768px) {
        --progress-bar-height: 52px;
    }

    float: none !important;
    height: 100% !important;
    margin-top: 0px !important;
    padding: 0px !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: 0 !important;

    .sections-navbar,
    .progress-bar-container,
    .search-bar-container {
        flex-shrink: 0;
        padding-right: 0px;
        padding-left: 0px;
    }

    .progress-bar-section {
        flex-shrink: 0;
    }

    .detail-box {
        display: flex;
        flex-direction: column;
        background: transparent;
        flex: 1 1 auto;
        min-height: 0;
        height: auto !important;
        padding-bottom: 0px;

        .exam {
            flex: 1 1 auto;
            min-height: 0;
            height: auto !important;
            overflow-x: hidden;
            overflow-y: auto;
            padding-bottom: env(safe-area-inset-bottom, 0px);

            .settings {
                span {
                    @include font-size(s);
                }
            }

            .justify-description,
            .check-available {
                padding: 8px 20px 8px 50px;
                background-size: 25px;
                background-position: left 10px center;

                .message {
                    @include font-size(xs);
                    line-height: 0.75rem;
                    width: calc(100% - 100px);
                }

                .action {
                    width: 100px;
                    @include font-size(xs);
                    line-height: 0.75rem;
                }
            }

            .check-available {
                .message {
                    width: 100%;
                    max-width: 100%;
                }
            }

            .answer {
                .line {
                    .statement {
                        .answer-title {
                            @include font-size(xs, $important: true);
                        }
                    }
                }
            }

            .get-last-values {
                .message {
                    @include font-size(xs);
                    line-height: normal;
                }
            }
        }
    }

    .top-container {
        flex-shrink: 0;
        height: auto;
        max-height: none;
        padding: 0px;
    }
}

.qr-scanner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2147483646;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qr-scanner-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    ::v-deep video {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.qr-scanner-reader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.qr-scanner-close {
    /* Por defecto: fixed + 56px (HEAD). Variante .qr-scanner-close--inset: absolute + 16px (red-team) */
    position: fixed;
    top: 56px;
    right: 16px;

    &--inset {
        position: absolute;
        top: 16px;
    }

    z-index: 2147483647;
    display: inline-flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid var(--color-Neutral-300, #b8b8b8);
    background: var(--color-Neutral-White, #fff);
    cursor: pointer;

    .i-andy-close {
        color: var(--color-Neutral-800, #424242);
    }

    @media (max-width: 768px) {
        top: calc(72px + env(safe-area-inset-top, 0px));
        right: 12px;
        width: 48px;
        height: 48px;
        padding: 10px;
    }
}
</style>
